<template>
  <section id="contact" class="position">
    <Title :title="category.name" :description="category.description" />

    <div class="section-content">
      <div class="row">
        <div class="col-12 col-md">
          <div class="contact-box">
            <i :class="personalInfo.meta.phone_icon"></i>
            <h3>Phone Number:</h3>
            <p>{{ personalInfo.meta.phone }}</p>
          </div>
          <div class="contact-box">
            <i :class="personalInfo.meta.adress_icon"></i>
            <h3>Address:</h3>
            <p>{{ personalInfo.meta.city }}</p>
          </div>
        </div>

        <div class="col-md-6 col-sm-6">
          <form
            @submit.prevent="formSubmited"
            action="https://formspree.io/f/maykqpgr"
            method="POST"
          >
            <label class="form-group">
              <div class="title-input">
                <div>
                  <span class="star-required">*</span>Full Name:
                </div>
                <transition name="fadeRight">
                  <div class="validation" v-if="!isValidName">Name is required!</div>
                </transition>
              </div>
              <input type="text" v-model="name" v-validity="isValidName" name="name" required />
            </label>

            <label class="form-group">
              <div class="title-input">
                <div>
                  <span class="star-required">*</span>E-mail:
                </div>
                <transition name="fadeRight">
                  <div class="validation" v-if="!isValidName">E-mail is required!</div>
                </transition>
              </div>
              <input type="email" v-model="email" v-validity="isValidEmail" name="_replyto" required />
            </label>

            <label class="form-group">
              <div class="title-input">
                <div>
                  <span class="star-required">*</span>Message:
                </div>
                <transition name="fadeRight">
                  <div class="validation" v-if="!isValidName">Enter something, please...</div>
                </transition>
              </div>
              <textarea type="text"v-model="message" v-validity="isValidMessage" name="message" required></textarea>
            </label>

            <button class="btn-sent">Send</button>
            <transition name="fadeRight">
                  <div class="validation" v-if="!isSent">Sent! I'll get back to you soon! Have a great day!</div>
            </transition>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { group } from "../utils";
import Title from "./Title";
import PersonalInfo from "./PersonalInfo";

export default {
  name: "Contacts",
  props: ["category", "posts"],
  components: {
    Title,
    PersonalInfo,
  },
  data: () => ({
    name: "",
    email: "",
    message: "",
    isValidName: true,
    isValidEmail: true,
    isValidMessage: true,
    isSent: true,
  }),
  computed: {
    groupedPosts() {
      return group(this.posts);
    },
    personalInfo() {
      return this.groupedPosts["personal-information"];
    },
  },
  methods: {
    formSubmited(ev) {
      ev.preventDefault();
      const form = ev.target;
      const data = new FormData(form);
      const xhr = new XMLHttpRequest();
      xhr.open(form.method, form.action);
      xhr.setRequestHeader("Accept", "application/json");
      xhr.onreadystatechange = () => {
        if (xhr.readyState !== XMLHttpRequest.DONE) return;
        if (xhr.status === 200) {
          form.reset();
          //this.setState({ status: "SUCCESS" });
          this.isSent = false
          console.log("Se envio");
        } else {
          //this.setState({ status: "ERROR" });
          console.log("No se envio")

        }
      };
      xhr.send(data);

      setTimeout(() => {
        this.name = this.email = this.message = "";
      }, 100);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

$bg-contact: map-get($colors, dark) !default;

#contact {
  background-color: lighten($bg-contact, 84.6%);

  .row {
    margin-top: 20px;
  }
}

.contact-box {
  margin: 30px 0;
  padding: 0 10px;

  h3 {
    text-align: left;
    color: map-get($colors, dark);
    margin-bottom: 0px;
    font-size: 1.4rem;
  }

  i {
    font-size: 4rem;
    margin-left: -12px;
    color: map-get($colors, secondary);
  }

  p {
    margin-top: 5px;
  }
}

.errors-block {
  color: #f12b2b;
}

.btn-sent {
  border: none;
  color: #fff;
  line-height: 40px;
  padding: 0 25px;
  font-size: 1.5rem;
  text-transform: uppercase;
  font-weight: 600;
  margin-top: 10px;
  float: right;
  background-color: map-get($colors, secondary);
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.6);

  &:active {
    margin-bottom: 2px;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.6);
  }

  &:focus {
    outline: none;
  }
}

form {
  padding: 0 10px;
}

.form-group {
  display: block;
  margin-bottom: 20px;

  .star-required {
    font-weight: 900;
    font-size: 2rem;
    color: map-get($colors, secondary);
  }

  .title-input {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .validation {
    color: map-get($colors, error);
    animation-duration: 0.5s;
  }

  input,
  textarea {
    display: block;
    width: 100%;
    border: 1px solid lighten($bg-contact, 60%);
    margin-top: 5px;
    line-height: 4rem;
    text-indent: 1rem;
    font-size: 1.4rem;
    outline: none;
    background-color: transparent;
  }
}
</style>
